import { useLayoutEffect, useRef } from 'react';

export function useLatestValue<T>(value: T) {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
